<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r grey lighten-5">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <div class="text-xs-left f-20">Classes</div>
        <v-spacer></v-spacer>
        <div class="text-xs-right pa-2">
          <v-btn class="ma-0 right white text-primary card-r no-shadow" to="createclass">Add Class</v-btn>
        </div>
        <div class="text-xs-left pa-2 text-xs-right">
          <v-btn class="ma-0 white text-primary card-r no-shadow" @click="loadPopup()">Import Classes</v-btn>
        </div>
      </v-toolbar>
    </v-card>
      <v-layout wrap>
        <!--<v-flex xs12 class="">-->
        <!--<v-flex xs6 class="">-->
        <!--<div class="text-xs-left pa-2">-->
        <!--<v-btn class="mb-0 ml-3 secondary text-white card-r no-shadow" to="createclass"> Add Class</v-btn>-->
        <!--</div>-->
        <!--</v-flex>-->
        <!--<v-flex xs6 class="right text-xs-right">-->
        <!--<div class="text-xs-left pa-2 text-xs-right">-->
        <!--<v-btn class="mb-0 mr-3 primary text-white card-r no-shadow" @click="loadPopup()">Import Classes</v-btn>-->
        <!--</div>-->
        <!--</v-flex>-->
        <!--</v-flex>-->
        <v-flex xs12 class="">
          <div class="transparent card-r mt-2 text-xs-center ">
            <!--<h1 class="">My Classes</h1>-->
            <!--  <div class="text-xs-left pa-2">
               <v-btn class="mb-0 ml-4 secondary text-white card-r no-shadow" to="createclass">Add Class</v-btn>
             </div> -->
            <v-container fluid grid-list-xl class="pa-0">
              <v-layout row wrap class="">
                <v-flex d-flex lg3 sm6 xs12 v-for="(n, index) in modules" v-bind:key="index">
                  <v-card class="shadow-1 card-r">
                    <router-link v-bind:to="'/viewclass/'+n.id" class="no-deraction">
                      <v-img v-bind:src="n.image"
                             height="150px"
                             class="card-r">
                        <div class="text-xs-right w-100">
                          <v-btn class="white shadow-1 card-r" icon v-bind:to="'editclass/'+n.id"><v-icon class="select-pack-color blue-grey--text">edit</v-icon></v-btn>
                          <!--<v-btn class="white shadow-1" icon><v-icon class="select-pack-color blue-grey&#45;&#45;text" @click="deleted = true">delete</v-icon></v-btn>-->
                        </div>
                      </v-img>
                    </router-link>
                    <v-card-title primary-title>
                      <div class="text-xs-left">
                        <div class="f-14" style="color: #424242;">{{n.name}}</div>
                        <div style="color: #424242;">
                          <span class="f-12 font-weight-bold text--darken-1">Mins : - </span>
                          <span class="f-12 font-weight-bold text--darken-1">{{n.hours}} mins</span>
                        </div>
                        <div style="color: #424242;">
                          <!--<span class="f-15 font-weight-bold text&#45;&#45;darken-1 ">Price : - </span>
                          <span class="f-15 font-weight-bold text&#45;&#45;darken-1 ">KR {{n.price}}</span>-->
                        </div>
                        <!-- <span class="grey--text">  {{n.description}}</span> -->
                        <v-chip v-for="(x,index) in n.tags.slice(0,3)" color="primary" text-color="white">{{x.description.substring(0,4)}}...</v-chip>
                      </div>
                    </v-card-title>
                    <v-card-actions>
                      <!-- <ConfirmDelete v-bind:className="n.name"/> -->
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
      <!--<v-dialog v-model="deleted" max-width="290">-->
        <!--<v-card class="card-r">-->
          <!--<v-card-title class="f-17 text-capitalize">Are You Sure Want To Delete <span class="font-weight-bold f-17">{{modules.name}}</span>?</v-card-title>-->
          <!--<v-card-actions>-->
            <!--<v-spacer></v-spacer>-->
            <!--<v-btn class="grey text-white left card-r" text @click="deleted = false">No</v-btn>-->
            <!--<v-btn class="primary text-white card-r" text @click="deleted = false">Yes</v-btn>-->
          <!--</v-card-actions>-->
        <!--</v-card>-->
      <!--</v-dialog>-->

      <v-dialog v-model="DownloadClassPopup" max-width="525">
        <v-card class="no-shadow pa-3 card-r">
          <div  class="text-xs-center">
            <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20">Import Classes</div>
            </v-toolbar>
          </div>
          <v-layout>
            <v-flex>
              <v-flex xs12 class="pt-2">
                <v-list>
                  <v-card color="white" class="card-r no-shadow"  v-if="!loading">
                    <div v-for="val in filteredClasses" v-if="filteredClasses.length!=0">
                      <v-checkbox class="pa-0 ma-0" color="primary darken-2" v-model="selectedClasses" :label="val.name" :value="val.id"></v-checkbox>
                    </div>
                    <div v-if="filteredClasses.length==0">
                      <v-alert
                        :value="true"
                        type="info"
                      >
                        There are no classes found
                      </v-alert>
                    </div>
                  </v-card>
                  <!-- <BulletListLoader v-if="loading" :width="250" :height="100"></BulletListLoader> -->
                  <v-flex xs12 class="text-xs-center mr-1">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      v-if="loading"
                    ></v-progress-circular>
                  </v-flex>
                </v-list>
              </v-flex>
              <v-flex xs12 class="text-xs-left mr-1">
                <v-alert v-if="alertType" :type="alertType" :value="true">
                  {{msg}}
                </v-alert>
              </v-flex>
              <v-layout xs12>
                <v-flex xs12 class="text-xs-right">
                  <v-btn @click="DownloadClassPopup = false" class="grey text-white card-r">Cancel</v-btn>
                  <v-btn @click="importClasses(), dialog = false" class="card-r primary darken-2 text-white card-r">Import</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>

      </v-dialog>
  </v-container>
</template>
<style>

  .view-package-main-container{
    color: #7f7f7f ;
  }
  .view-package-main-container .v-carousel__controls{
    background-color: transparent !important;
  }
  .view-package-carousel .v-btn:before{
    background-color: #0069b3 !important;
  }
  .view-package-carousel .fa-circle:before{
    color: #7f7f7f!important;
  }
  .view-package-main-container h1{
    color: #454545!important;
    font-weight: 500;
  }
  .view-package-main-container p{
    color: #7f7f7f !important;
    text-align: justify !important;
    font-weight: 100;
  }
  .view-content-card{
    color: #7f7f7f !important;
  }
  .view-button {
    background-color: #0051a0 !important;
  }
  .v-dialog{
    box-shadow: none!important;
  }
</style>
<script>
  /* eslint-disable */
  import ConfirmDelete from "./ConfirmDelete";
  import { mapState, dispatch } from "vuex";
  import api from "@/utils/backend-api"
  import { BulletListLoader } from 'vue-content-loader'
  export default {
    data: () => ({
      deleted : false,
      loading:false,
      tags:'',
      show: false,
      dialog: false,
      ModulesList: "",
      DownloadClassPopup:'',
      Clubs:[],
      Minutes:[45,90,135,180,225],
      selectedMinute:'',
      selectedClub:'',
      filteredClasses:[],
      selectedClasses:[],
      alertType:'',
      msg:'',
      return: {
        // items: [
        //   {
        //     src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
        //   },
        //   {
        //     src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
        //   },
        //   {
        //     src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
        //   },
        //   {
        //     src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
        //   }
        // ]
      },
    }),
    created:function(){

      Store.commit("setLoading", { loading: true });
      this.loadClubClasses()
    },
    methods:{

      //   })
      //   this.loading=true
      //   this.filterModules()
      //   this.DownloadClassPopup=true
      // },
      filterModules(){
        this.loading=true
        let self=this

        api.postData('admin/viewModuleTemplate')
          .then(res=>{
            self.filteredClasses=res.data
            this.loading=false
          }).catch(err=>{
          self.filteredClasses=[]
          this.loading=false
        })
        this.selectedClasses=[]
      },

    //   loadClubClasses ({commit}) {
    //   commit('setLoading', { loading: true })
    //   api.getData('admin/module').then(res => {
    //     var modules = res.Data
    //     commit('setModulesData', modules)
    //     commit('setLoading', { loading: false })
    //   })
    // },

     loadClubClasses(){
        let self=this
        api.getData('admin/module')
        // .then(res=>{
        //     self.$store.dispatch('setModulesData',res.data)
        // }).catch(err=>{
        //     self.$store.dispatch('setModulesData',[])
        // })
      },
      importClasses(){
        let self=this
        this.loading=true
        api.postData('admin/copyModules',{module_template_id:this.selectedClasses})
          .then(res=>{
            this.alertType="success"
            this.msg="Successfully imported"
            self.loadClubClasses()
            this.loading=false
            setTimeout(()=>{
              self.DownloadClassPopup=false
            },1200);
          }).catch(err=>{
          this.loading=false
          this.alertType="error"
          this.msg="Import failed"
        })
      }
    },

    computed: {
      ...mapState({
        modules: Modules => Store.state.Modules.modules
      })
    },
    components: {
      BulletListLoader,
      ConfirmDelete
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/classes/Classes.vue